import { render, staticRenderFns } from "./ResultComponent.vue?vue&type=template&id=524f4f3a&scoped=true&"
import script from "./ResultComponent.vue?vue&type=script&lang=js&"
export * from "./ResultComponent.vue?vue&type=script&lang=js&"
import style0 from "./ResultComponent.vue?vue&type=style&index=0&id=524f4f3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524f4f3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCardTitle,VCol,VContainer,VRow})
